import CustomTitle from "../../components/CustomMiscellaneous/CustomTitle";
import { generalObjectBuilder, genericDelete, genericPost, genericUpdate, paginatedGetWithProcessor } from "../../services/api.service";
import { PecasTableConfig } from "./Pecas.config";
import TableView from "../Common/TableView";
import { useLocation } from "react-router-dom";


export default function Pecas() {

    const location = useLocation();
    const currentRoute = location.pathname;
    const obraId = currentRoute.split("/")[2];

    const EXTENSION = `/obras/${obraId}/pecas`;

    return(<>{EXTENSION ? <div>
        <TableView 
        title={"Peças"}
        getEntity={paginatedGetWithProcessor(EXTENSION, generalObjectBuilder(PecasTableConfig))}
        postEntity={genericPost(EXTENSION)}
        editEntity={genericUpdate(EXTENSION)}
        deleteEntity={genericDelete(EXTENSION)}
        addButtonText={"Nova Peça"} 
        searchButtonText={"Procurar Peça"}
        tableConfigs={PecasTableConfig}
        dataBuildFunction={generalObjectBuilder(PecasTableConfig)}
        entityName={"Peças"}
        idProp={"reference"}
        configMapKey={`obras/${obraId}/pecas`}
        hidePagination
        hideFilters
        reroute={true}
        isSubTable
          />
    </div>:null}</>)

}